import React from "react";

import ECD from "../components/ECD";

const PaintPrep = (props) => {
    return (
        <div>
            <div class="container">
                <div class="row">
                    <div className="row customer-support text-center" style={{ marginTop: 10 }}>
                        <h4 style={{ color: "black" }}>{props.VehEntry.Veh_Year} {props.VehEntry.Veh_Make} {props.VehEntry.Veh_Model}</h4>
                        <p style={{ marginTop: 10, color: "black" }}>Paint Prep</p>
                        <p><b>{props.Veh_Year}</b></p>
                    </div>
                </div>
            </div>
            <div className="sec-title text-left" style={{ marginTop: 10 }}>
                <h4 style={{ color: "black" }}>What does this mean?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>During this phase, all necessary preparations are made to your vehicle before it enters the paint booth.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>What is next?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>The vehicle will move into the paint booth next. At this time, any new parts will also be painted for the vehicle. Depending on your vehicle's paint type, this could include two or three applications. After the paint has had time to cure, your vehicle will be moved to the re-assembly phase where we will begin putting the vehicle back together.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>Estimated Completion Date</h4>
                <span className="decor" />
                <ECD ecd={props.VehEntry.EstimatedCompletionDate} />
            </div>
        </div>
    )
}

export default PaintPrep